import Paper from "@material-ui/core/es/Paper/Paper";
import React from "react";
import ActionBar from "../components/ActionBar";
import FormView from "../components/FormView";
import Loader from "../components/Loader";
import * as API from "../util/api";
import * as Util from "../util/util";
import * as Variant from "../util/variant";
import VLComponent from "./VLComponent";

const isValidLatLng = value => value !== "" && !isNaN(value);

class EditScreen extends VLComponent {
  constructor() {
    super();
    this.state = { loaded: false, groups: [], sensor_name: "", isV5: false };
  }

  componentDidMount() {
    Util.getLocation(pos => {
      this.setState({ lat: pos.coords.latitude, lng: pos.coords.longitude });
    });

    API.POST("account/getInfo", {}, result => {
      Util.handleLogout(result);
      if (result.success) {
        this.setState({ twitter_default: result.result.twitter_default });
      }
    });

    API.POST("systems/list", { sensor_id: this.props.id }, result => {
      Util.handleLogout(result);
      if (!result.success) return;

      const sensor = (result.result.sensors || [])[0];
      if (!sensor) return;

      // V5 detection: list response includes idv5_camera (populated)
      const isV5 = !!sensor.idv5_camera;

      // Preserve existing behaviour: shove sensor fields into state
      this.setState({ ...sensor, isV5 });

      const groups = (result.result.groups || []).filter(a => a != null && a !== "null");
      this.setState({ groups });

      if (sensor.outstation_type === 3) {
        this.setState({ hiRes: true });
      }

      // PTZ labels (V1 only)
      if (!isV5) {
        const ptz = this.state.ptz_info || [];
        for (let i = 1; i <= 4; i++) {
          const info = ptz[i - 1];
          const tag = info == null ? "" : info.tag;
          this.setState({ ["ptz_name_" + i]: tag });
        }
      }

      // Keep existing "loaded" gating
      if (sensor.variant !== Variant.IP_CAMERA) {
        this.setState({ loaded: true });
      }
    });
  }

  render() {
    return (
      <div>
        <ActionBar title={"Edit System - " + (this.state.sensor_name || "")} />
        {this.renderTextAlert()}
        <div
          id="content"
          style={{
            display: this.state.loaded ? "flex" : "none",
            maxHeight: "calc(100vh - 70px)",
            padding: 24,
            overflowY: "auto",
            justifyContent: "center"
          }}
        >
          <Paper
            style={{
              padding: 16,
              borderRadius: 8,
              width: "20cm",
              maxWidth: "90vw",
              maxHeight: "calc(100vh - 120px)",
              overflowY: "auto"
            }}
          >
            <FormView items={this.getItems()} changeEvent={this.handleInputChange} />
          </Paper>
        </div>
        <Loader loaded={this.state.loaded} />
      </div>
    );
  }

  getItems = () => {
    const isV5 = !!this.state.isV5;

    // Base (shared UI fields that exist in both payloads)
    let r = [
      { type: "title", text: this.state.variant !== Variant.GAUGE ? "Camera Properties" : "Sensor Properties" },
      { id: "sensor_name", name: "System Name", value: this.state.sensor_name, type: "text" },
      { id: "sensor_postcode", name: "System Postcode", value: this.state.sensor_postcode, type: "text" },
      { id: "sensor_lat", name: "Latitude", value: this.state.sensor_lat, type: "text" },
      { id: "sensor_long", name: "Longitude", value: this.state.sensor_long, type: "text" },
      { id: "grid_ref", name: "Grid Ref", value: this.state.grid_ref, type: "text" },
      { id: "community_app_view_en", name: "Community App", value: !!this.state.community_app_view_en, type: "bool" },
      { id: "linked_name", name: "Contact Name", value: this.state.linked_name, type: "text" },
      { id: "linked_email", name: "Email Address", value: this.state.linked_email, type: "text" }
    ];

    // V1-only fields
    if (!isV5) {
      r = r.concat([
        { id: "asset_id", name: "Asset ID", value: this.state.asset_id, type: "text" },
        { id: "admin_only", name: "Admins Only", value: !!this.state.admin_only, type: "bool" }
      ]);
    }

    // Camera blur is applicable (V1+V5 camera variants; not gauges)
    if (this.state.variant !== Variant.GAUGE) {
      r = r.concat([
        { id: "image_auto_blur", name: "Auto Image Blur", value: !!this.state.image_auto_blur, type: "bool" }
      ]);
    }

    // V5 extras (based on your new products)
    if (isV5 && this.state.variant !== Variant.GAUGE) {
      r = r.concat([
        { id: "car_reg_blur", name: "Car Reg Blur", value: !!this.state.car_reg_blur, type: "bool" },
        // Keep these tied to what the backend expects / what you already pass around
        { id: "image_people_push_en", name: "People Detection", value: !!this.state.image_people_push_en, type: "bool" },
        { id: "image_vehicles_push_en", name: "Vehicle Detection", value: !!this.state.image_vehicles_push_en, type: "bool" }
      ]);
    }

    // PTZ labels (V1 only)
    if (!isV5 && this.state.ptz_system) {
      for (let i = 1; i <= 4; i++) {
        const tag = this.state["ptz_name_" + i];
        r.push({ id: "ptz_name_" + i, name: "PTZ Label " + i, value: tag, type: "text" });
      }
    }

    return r.concat([{ type: "button", text: "Save", onClick: this.save }]);
  };

  save = () => {
    if (!isValidLatLng(this.state.sensor_lat)) {
      alert("Invalid latitude");
      return;
    }
    if (!isValidLatLng(this.state.sensor_long)) {
      alert("Invalid longitude");
      return;
    }

    const isV5 = !!this.state.isV5;

    // V1: keep *exactly* the old payload shape
    if (!isV5) {
      let data = this.filterState([
        "sensor_id",
        "sensor_name",
        "sensor_postcode",
        "sensor_lat",
        "sensor_long",
        "asset_id",
        "grid_ref",
        "linked_email",
        "linked_name",
        "image_auto_blur",
        "community_app_view_en",
        "admin_only",
        "system_group",
        "twitter_feed",
        "ptz_name_1",
        "ptz_name_2",
        "ptz_name_3",
        "ptz_name_4",
        "image_people_push_en",
        "image_vehicles_push_en"
      ]);

      data.community_view = data.community_app_view_en ? 1 : 0;
      data.admin_only = data.admin_only ? 1 : 0;
      data.auto_blur = data.image_auto_blur ? 1 : 0;
      data.image_people_push_en = data.image_people_push_en ? 1 : 0;
      data.image_vehicles_push_en = data.image_vehicles_push_en ? 1 : 0;

      API.POST("systems/setInfo", data, result => {
        if (result.success) {
          this.basicAlert("Your changes have been saved", () => window.history.back());
        } else {
          console.log(result.error);
          this.basicAlert(result.error);
        }
      });
      return;
    }

    // V5: send only V5-applicable edit fields
    let data = this.filterState([
      "sensor_id",
      "sensor_name",
      "sensor_postcode",
      "sensor_lat",
      "sensor_long",
      "grid_ref",
      "linked_email",
      "linked_name",
      "image_auto_blur",
      "community_app_view_en",
      "car_reg_blur",
      "image_people_push_en",
      "image_vehicles_push_en"
    ]);

    data.community_view = data.community_app_view_en ? 1 : 0;
    data.auto_blur = data.image_auto_blur ? 1 : 0;
    data.car_reg_blur = data.car_reg_blur ? 1 : 0;
    data.image_people_push_en = data.image_people_push_en ? 1 : 0;
    data.image_vehicles_push_en = data.image_vehicles_push_en ? 1 : 0;

    API.POST("systems/setInfoV5", data, result => {
      if (result.success) {
        this.basicAlert("Your changes have been saved", () => window.history.back());
      } else {
        console.log(result.error);
        this.basicAlert(result.error);
      }
    });
  };
}

export default EditScreen;
